import React from 'react';
import { Link } from 'react-router-dom';
//import blog3 from '../../images/blog-details/comments-author/img-1.jpg';
//import blog4 from '../../images/blog-details/comments-author/img-2.jpg';
//import blog5 from '../../images/blog-details/comments-author/img-3.jpg';
//import blog6 from '../../images/blog-details/author.jpg';
import blog7 from '../../images/blog-details/image-4.jpg';
import blog8 from '../../images/blog-details/image-5.jpg';
import blogs from '../../api/blogs';
import { useParams } from 'react-router-dom';

const BlogSingle = props => {
	const { slug } = useParams();

	const NewsDetails = blogs.find(item => item.slug === slug);

	const submitHandler = e => {
		e.preventDefault();
	};

	const ClickHandler = () => {
		window.scrollTo(10, 0);
	};

	return (
		<section className='py-[120px] md:py-[90px] sm:py-[80px]'>
			<div className='wraper'>
				<div className={`${props.gClass} grid gap-3`}>
					<div className={`col-span-8 md:col-span-12 ${props.blRight}`}>
						<div className=''>
							<div className='mb-[70px]'>
								<h3 className='text-[34px] md:text-[25px] sm:text-[22px] text-[#282e3f] font-normal font-heading-font leading-[40px] pt-7 transition-all mb-[20px] group'>
									{NewsDetails.title}
								</h3>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									{NewsDetails.description}
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									Les dispositions du Livre 6 s'appliquent aux faits susceptibles d'entraîner une
									responsabilité qui se sont produits après son entrée en vigueur, soit le 1er janvier
									2025. L'ancien régime reste donc d'application pour les événements dommageables qui
									se sont produits avant cette date.
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									L'objet de cet article est circonscrit à la responsabilité des mineurs et des
									parents.
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									Pour rappel, la majorité légale en Belgique est fixée à 18 ans.
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									Le Livre 6 introduit un nouveau régime de responsabilité pour les mineurs. En effet,
									l'article 6.9 dispose désormais que{' '}
									<i>
										« <u>Le mineur de moins de douze ans</u> n'est pas responsable du dommage causé
										par sa faute ou par un autre fait générateur de responsabilité. »
									</i>
									. Autrement dit, le jeune âgé de moins de douze ans est exonéré de toute
									responsabilité personnelle.
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									Par contre, en ce qui concerne <u>les mineurs de douze ans et plus</u>, l'article
									6.10 dispose qu'ils sont responsables du dommage causé par leur faute ou par tout
									autre fait générateur de responsabilité. Autrement dit, un mineur de douze ans ou
									plus peut engager sa responsabilité personnelle.
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									Néanmoins, le législateur a prévu que le juge peut supprimer ou limiter la
									réparation du dommage causé par un tel jeune lorsque les circonstances et la
									situation économique et financière des parties le justifient. Toutefois, lorsque la
									responsabilité du mineur est couverte par un contrat d'assurance, le juge ne peut
									pas décider qu'aucune indemnité n'est due, ni limiter l'indemnité à un montant
									inférieur à celui pour lequel ce contrat d'assurance accorde une couverture.
									Autrement dit, l'assureur du responsable ou couvrant la responsabilité civile du
									jeune est lié par l'indemnité dont le mineur est redevable ou par la limite de
									garantie prévue par le contrat d'assurance.
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									Concernant les personnes qui doivent répondre des enfants de moins de 18 ans, le
									Nouveau Livre 6 introduit une nouveauté en ce que la responsabilité des parents
									n'est plus la seule visée. En effet, le législateur vise désormais la{' '}
									<i>« Responsabilité des titulaires de l'autorité sur la personne des mineurs »</i>.
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									Parmi ces titulaires de l'autorité sur la personne des mineurs, les adoptants,
									tuteurs et accueillants familiaux sont désormais visés à côté des parents. Il s'agit
									d'une petite révolution en la matière.
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									Ces titulaires de l'autorité sur <u>une personne mineure de moins de seize ans</u>{' '}
									seront désormais d'office responsables du dommage causé à des tiers par celui-ci par
									sa faute ou par un autre fait générateur de responsabilité. Autrement dit, ces
									titulaires de l'autorité sur un jeune de 15 ans ou moins ne pourront plus s'exonérer
									de leur responsabilité.
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									Concernant <u>les mineurs de plus de seize ans</u>, les titulaires de l'autorité sur
									ces derniers pourront s'exonérer de toute responsabilité s'ils parviennent à
									démontrer que le dommage ne trouve pas sa cause dans une faute de leur part.
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									En bref, il faut désormais retenir qu'un mineur de moins de douze ans ne peut plus
									engager sa responsabilité personnelle tandis que les personnes titulaires de
									l'autorité sur une personne mineure de moins de seize ans seront d'office
									responsables du dommage causé à des tiers par la faute du mineur même si celui-ci a
									moins de douze ans !
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									Au regard de ces changements, il est impératif de souscrire une assurance R.C. Vie
									Privée (on disait auparavant RC Familiale) pour couvrir sa responsabilité que l'on
									soit parents, adoptants, tuteurs ou accueillants familiaux !
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									Souscrire une assurance R.C. Vie Privée, c'est éviter les mauvaises surprises après
									!
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default BlogSingle;
